<template>
  <div>
    <MessageContainer :title="'dratf'" :icon="'edit'" />
  </div>
</template>

<script>
import MessageContainer from "@/components/messages/MessageConatiner";

export default {
  name: "dratf",
  components: {
    MessageContainer,
  },
};
</script>
